export interface NodeData {
  id: string;
  appName?: string;
  category?: string;
}

export const butterflyData: NodeData[] = [
  { id: 'Deel', appName: 'Deel', category: 'applications' },
  { id: 'DocuSign', appName: 'DocuSign', category: 'applications' },
  { id: 'Kantata', appName: 'Kantata', category: 'applications' },
  { id: 'Gitlab', appName: 'Gitlab', category: 'applications' },
  { id: 'Webex', appName: 'Webex', category: 'applications' },
  { id: 'Saviynt', appName: 'Saviynt', category: 'applications' },
  { id: 'Gsuit', appName: 'Gsuit', category: 'applications' },
  { id: 'Mode', appName: 'Mode', category: 'applications' },
  { id: 'Netsuite', appName: 'Netsuite', category: 'applications' },
  { id: 'Onelogin', appName: 'Onelogin', category: 'applications' },
  { id: 'Slack', appName: 'Slack', category: 'applications' },
  // { id: 'Salesforce', appName: 'Salesforce', category: 'applications' },
  // { id: 'Zoom', appName: 'Zoom', category: 'applications' },
  { id: 'MSOffice365', appName: 'MSOffice365', category: 'identity' },
  { id: 'Tenable', appName: 'Tenable', category: 'identity' },
  { id: 'Thycotic', appName: 'Thycotic', category: 'identity' },
  { id: 'TopSecret', appName: 'TopSecret', category: 'identity' },
  { id: 'VevaVault', appName: 'VevaVault', category: 'vaults' },
  { id: 'Vault', appName: 'Vault', category: 'vaults' },
  { id: 'OneKosmos', appName: 'OneKosmos', category: 'vaults' },
];
